module.exports = __webpack_public_path__ + "img/internacional.8601346c.jpg";